import _errorsMap from '../_api/errorsMap';

const validationErrorMessages = {
  max_order_count: 'Máximo de pedidos válidos deve ser maior ou igual ao mínimo de pedidos válidos.',
};

export default (errorSlugs,) => {
  return _errorsMap.filter((error,) => errorSlugs.some((value,) => error[value],),);
};


export {
  validationErrorMessages,
};
